import { useMutation } from "@tanstack/react-query";
import api from "apis";

export const useDeleteDocumentMutation = (uuid: string) => {
  return useMutation({
    mutationFn: () => api.document.deleteDocument(uuid),
  });
};
